

import React, { useState } from 'react';

import { Authenticator } from '@aws-amplify/ui-react';

import "@aws-amplify/ui-react/styles.css";

import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../../components/button/MasterButton";
import "./LandingPage.css";
// import { useAuth0 } from "@auth0/auth0-react"; <- remove this - using the previously used Auth0 authentication

import { useSharedState } from '../../context/sharedState';

import logo from "../../assets/Logo.svg";
import circles from "../../assets/Circles.svg";
import circleBig from "../../assets/CircleBig.svg";
import loginIcon from "../../assets/LoginIcon.svg";

const LandingPage = () => {
  // const { loginWithRedirect } = useAuth0(); <- remove this - using the previously used Auth0 authentication

  const { isMobile } = useSharedState();

  const [showAuthenticator, setShowAuthenticator] = useState(isMobile ? true : false);

  const handleLoginClick = () => {
    setShowAuthenticator(true);
  };

  return (

    <div>
      {!showAuthenticator ? (

        <div className="login-page">
          <img alt="logo" className="logo" src={logo}></img>

          <img alt="background" className="circles" src={circles}></img>

          <img alt="background overlay" className="circle-big" src={circleBig}></img>

          <div className="login-form">
            <div className="display-medium title">Welcome to Emerja!</div>

            <div className="title-medium description">Bridging professionals and patients, realizing sustainable healthcare</div>

            <div className="button-container">
              <MasterButton
                options={{
                  layoutType: ButtonLayoutType.IconLabel,
                  size: ButtonSize.Large,
                  variation: ButtonVariation.PrimaryFilled,
                  label: "Login",
                  icon: loginIcon,
                  className: "button",
                }}
                // onClick={function (): void {
                  // loginWithRedirect({ appState: { returnTo: "/" } }); <- remove this - using the previously used Auth0 authentication
                // }}
                onClick={handleLoginClick}
              ></MasterButton>
            </div>
          </div>
          <div className="body-medium contact">Contact | support@emerja.io</div>
        </div>
      ) : (
        <div className="login-container">

          <div className="login-left">
            <div className="login-form">
            <img src={logo} alt="Logo" className="logo custom-logo" />
            <div className="title title-small custom-title">Clinician Dashboard</div>
            <div className='border-box-override'>
              <Authenticator hideSignUp></Authenticator>
            </div>
            </div>
          </div>
          <div className="login-right">
            <div className="image-placeholder">Image Placeholder</div>
          </div>
          
        </div>
        
      )}
    
    </div>

  );
};

export default LandingPage;
